import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {BasePanelPage, BasePanelPageStyle} from "../../../PanelPage";
import {DonationAmountAndFrequency} from "./components/DonationAmountAndFrequency.jsx";
import {Flow} from "../../../flows/Flow.js";
import {styleRule} from "../../../../../stem-core/src/decorators/Style.js";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme.js";
import {BlinkButton} from "../../../../../core/ui/Button.jsx";


export class DonatePanelStyle extends BasePanelPageStyle {
    @styleRule
    button = {
        width: "100%",
        marginTop: 18,
    }
}

@registerStyle(DonatePanelStyle)
export class DonatePanel extends BasePanelPage {
    render() {
        return [
            <DonationAmountAndFrequency ref="donateComponent" onChange={() => this.redraw()}/>,
            <BlinkButton
                label={Flow.donationDetails.getDonateComponentButtonLabel()}
                disabled={!Flow.donationDetails.isValid()}
                onClick={() => this.donate()}
                className={this.styleSheet.button}/>,
        ];
    }

    donate() {
        Flow.paymentMethod.showPanel();
    }
}
